import { render, staticRenderFns } from "./qualification.vue?vue&type=template&id=08afea34&scoped=true"
import script from "./qualification.vue?vue&type=script&lang=js"
export * from "./qualification.vue?vue&type=script&lang=js"
import style0 from "./qualification.vue?vue&type=style&index=0&id=08afea34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08afea34",
  null
  
)

export default component.exports